import qs from 'qs'

export const useTableSort = (search, defaultSort = null) => {

    // Sorting functionality
    const queryParams = qs.parse(search, { ignoreQueryPrefix: true })
    const sortField = queryParams["sortField"]
    const sortDirection = queryParams["sortDirection"]
    const sortModel = []

    if(sortField !== "") {
        sortModel.push({
            field: sortField,
            sort: sortDirection
        })
    } else if(defaultSort) {
        sortModel.push({...defaultSort})
    }

    return sortModel
}